<template>
  <div class="dashboard-container">
    <div
      v-if="loading"
      class="progress-bar"
      :style="{ width: progress + '%' }"
    ></div>
    <div class="mb-2 page-title">
      <i class="bi bi-file-earmark-text"></i> Class List
    </div>

    <div class="mb-2 d-flex justify-content-end align-items-center">
      <!-- Search Bar -->
      <!--input 
        v-model="searchQuery" 
        type="text" 
        class="form-control w-auto" 
        placeholder="Search" 
        @input="searchMembers" 
      /-->

      <!-- Create Menu Button -->
      <router-link to="/admin/classes/create" class="button button-primary">
        <i class="bi bi-plus-square"></i> Add New
      </router-link>
    </div>

    <!-- Table to display navigation data -->
    <div class="table-responsive mt-3">
      <table class="table mb-0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Age Category</th>
            <th>Class Name</th>
            <th>Gender</th>
            <th>Weight Min</th>
            <th>Weight Max</th>
            <th>Actions</th>
          </tr>
        </thead>
        <!-- Wrapper element with v-if -->
        <tbody v-if="classes.length > 0">
          
          <tr v-for="(class_category, index) in classes" :key="class_category.id">
            <td>{{ index + 1 + (currentPage - 1) * perPage }}</td>
            <td>{{ class_category.age_category?.name }}</td>
            <td>{{ class_category.name }}</td>
            <td>{{ class_category.gender === 'male' ? 'Laki-laki' : (class_category.gender === 'female' ? 'Perempuan' : 'N/A') }}</td>
            <td>{{ class_category.weight_min }}</td>
            <td>{{ class_category.weight_max }}</td>
            <td class="action-column">
              <div class="d-flex gap-2 justify-content-end">
          <MenuAksi v-slot="{ tutup }">
            <button type="button" class="aksi__item"
                    @click="tutup(); EditClass(class_category.id)">
              <i class="bi bi-pencil-square"></i> Edit
            </button>
          </MenuAksi>
        </div>
            </td>
          </tr>
        </tbody>
        <!-- Fallback message when there is no data -->
        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center py-4 text-muted">No class found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination Controls -->
    <div class="d-flex justify-content-end mt-4">
      <AppPagination
        :current-page="currentPage"
        :total-pages="totalPages"
        :prev-page-url="prevPageUrl"
        :next-page-url="nextPageUrl"
        @change-page="changePage"
      />
    </div>

  </div>
</template>

<script>
import http from "@/services/http";
import MenuAksi from "@/components/ui/MenuAksi.vue";
import AppPagination from "@/components/ui/AppPagination.vue";

export default {
  name: "ClassList",

  components: { MenuAksi, AppPagination },
  data() {
    return {
      classes: [], // Array to hold paginated team members
      searchQuery: "", // User's search input
      currentPage: 1, // Current page of results
      perPage: 10, // Results per page
      totalPages: 0, // Total number of pages
      prevPageUrl: null, // URL of the previous page
      nextPageUrl: null, // URL of the next page
      loading: false,
      progress: 0,
    };
  },
  mounted() {
    this.loadClasses(); // Load menu data when the component is mounted
  },
  methods: {
    async loadClasses(page = 1) {
      this.loading = true;
      try {
        const response = await http.get("/category-classes", {
          params: {
            page,
            perPage: this.perPage,
            search: this.searchQuery.trim(),
          },
        });
        const {
          current_page,
          last_page,
          data,
          next_page_url,
          prev_page_url,
        } = response.data;

        this.classes = data;
        this.currentPage = current_page;
        this.totalPages = last_page;
        this.nextPageUrl = next_page_url;
        this.prevPageUrl = prev_page_url;
      } catch (error) {
        console.error("Error loading classes:", error);
      } finally {
        this.loading = false;
      }
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.loadClasses(page);
      }
    },


    searchClasses() {
      this.currentPage = 1; // Reset to page 1 for new search
      this.loadClasses();
    },

    async EditClass(id) {
      this.$router.push({ name: "EditClass", params: { id } });
    },

    deleteMenu(id) {
      // Implement logic to delete the menu (e.g., API call)

      // Parameter dipertahankan untuk saat fungsi ini diimplementasikan.

      void id;
    },
  },
  computed: {
    prevPageExists() {
      return this.currentPage > 1;
    },
    nextPageExists() {
      return this.currentPage < this.totalPages;
    },
  },
};
</script>

<style scoped>

.table th,
.table td {
  padding: 10px;
}






.form-control {
  width: 250px;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background: var(--grad-flame);
  animation: loader-animation 1.5s infinite;
}

/* Animasi garis loader */
@keyframes loader-animation {
  0% {
    width: 0;
    background: var(--grad-flame); /* Warna awal */
  }
  50% {
    width: 50%;
    background: var(--grad-flame); /* Warna saat animasi */
  }
  100% {
    width: 100%;
    background: var(--grad-flame);
  }
}
</style>
